/* eslint-disable */
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import { integer, decimal, required } from "vuelidate/lib/validators";
import { extend, date } from "quasar";
import Vue from "vue";
import { $http, camelCase, copyToClipboard, sanitizeString } from "@/assets/js/appFunc";
import ObjectUtils from "./object-utils";
import Events from "./events";
import _set from "lodash.set";
import _has from "lodash.has";
import _ from "lodash";
import { BigNumber } from "ethers";
const { FunctionFragment } = require("ethers/lib/utils");

export default {
    mixins: [ObjectUtils, Events],
    computed: {
        ...mapState("components", [
            "legacyElementState",
            "futureValues",
            "colorValue",
            "currentInterfaceModel",
            "data",
            "live",
            "readOnly",
            "designer",
            "processInstanceId",
            "properties",
            "components",
            "activityId",
            "parsed"
        ]),
        ...mapState("main", ["currentApplicationId"]),
        ...mapGetters("components", ["parsedAPI"]),
        ...mapGetters("apps", ["currentApp"])
    },
    methods: {
        ...mapMutations("components", ["updateFutureValues"]),
        ...mapActions("components", ["callIntegrationAPI", "callMetamaskIntegration"]),
        __generateCode() {
            let computedCode = camelCase(this.activeProperties.label || "");

            if (computedCode) {
                const codeList = [];
                const root = computedCode;
                let loop = 0;
                Object.entries(this.properties).forEach(([key, value]) => {
                    if (key !== this.activeComponent && value.__generics.code) {
                        codeList.push(value.__generics.code);
                    }
                });

                while (codeList.includes(computedCode)) {
                    computedCode = `${root}${++loop}`;
                }
            }

            return computedCode;
        },
        __getMappingAttributes(mapping) {
            const data = { type: null, key: null };

            if (mapping && mapping.startsWith("m_")) {
                const pathList = mapping.substring(2).split(".");

                if (pathList.length > 1) {
                    let cursor = this.parsed.modelClasses[pathList.splice(0, 1)[0]];

                    pathList.forEach(node => {
                        cursor = cursor && cursor.fields ? cursor.fields[node] : null;
                    });
                    if (cursor) {
                        data.type = cursor.type;
                        data.key = cursor.key;
                    }
                }
            }

            return data;
        },
        checkLengthRange(validations, val, fromNumber) {
            let isValid = true;
            const { minLengthValue, maxLengthValue} = validations;
            const valToCheck = fromNumber ? Number(val) : val.toString().length;
            if (minLengthValue > maxLengthValue || maxLengthValue < minLengthValue) {
                isValid = false;
            } else if (minLengthValue && maxLengthValue === undefined) {
                isValid = valToCheck >= minLengthValue;
            } else if (minLengthValue === undefined && maxLengthValue) {
                isValid = valToCheck <= maxLengthValue;
            } else if (minLengthValue !== undefined && maxLengthValue !== undefined) {
                isValid = valToCheck >= minLengthValue && valToCheck <= maxLengthValue;
            }
            return isValid;
        },
        __isRegexValid(regexStr) {
            try {
              new RegExp(regexStr);
              return true;
            } catch (e) {
              return false;
            }
        },
        __componentValidations(val, validations) {
            const { excludeSpCharacters, excludeNumbers, lengthState, validationType, intOrDecimalVal, nrDecimals, regexExpression } = validations;
            let isValid = true;
            const regex = /^[a-zA-Z0-9]*$/;
            const regexNumbers = /^[^0-9]*$/;

            if (val) {
                if (validationType === "text") {
                    if (excludeSpCharacters) {
                        isValid = regex.test(val);
                    }
                    if (excludeNumbers && isValid) {
                        isValid = regexNumbers.test(val);
                    }
                    if (lengthState && isValid) {
                        isValid = this.checkLengthRange(validations, val);
                    }
                } else if (validationType === "number") {
                    isValid = this.__typeValidation(val, intOrDecimalVal) && !isNaN(val);
                    if (isValid && intOrDecimalVal === "decimal" && val.toString().includes(".") && nrDecimals) {
                        isValid = val.toString().split(".")[1].length <= nrDecimals;
                    }
                    if (isValid && lengthState) {
                        isValid = this.checkLengthRange(validations, val, true);
                    }
                } else if (validationType === "other") {
                    let formattedRegex = "";
                    let isValidRegEx = this.__isRegexValid(regexExpression);
                    if (isValidRegEx) {
                        formattedRegex = new RegExp(regexExpression);
                    }
                    isValid = isValidRegEx ? formattedRegex.test(val) : false;
                }
            }

            return isValid;
        },
        __typeValidation(value, type) {
            let isValid = true;
            if (value) {
                if (type === "integer" || type === "decimal") {
                    const validateFunction = type === "integer" ? integer : decimal;
                    // isValid = validateFunction(value) && parseFloat(value) < 2147483647;
                    isValid = validateFunction(value);
                }
            }

            return isValid;
        },
        __typeValidationAll(value) {
            const allValidators = ["integer", "decimal"];
            const validTypeObject = {};

            allValidators.forEach(validator => {
                validTypeObject[validator] = required(value) && this.__typeValidation(value, validator);
            });

            return validTypeObject;
        },
        __executeCustomEvent(fn, data) {
            return fn.call(this.scriptScope, data);
        },
        __notifications(text, type, code = "notify") {
            setTimeout(() => {
                Vue.prototype.$toast.showNotify({
                    type: type,
                    message: text,
                    code: code,
                    timeout: 2000
                });
            }, 0);
        },
        __formatDateObject(dateObject, format) {
            const timeStamp = dateObject.getTime();
            return date.formatDate(timeStamp, format);
        },
        __getColorValue(sValue) {
            let hex = null;
            if (sValue) {
                hex = sValue && sValue.charAt(0) === "#" ? sValue : this.colorValue[sValue].value;
            }

            return hex;
        },
        __getColorString(sValue) {
            let stringColor = null;
            if (sValue) {
                if (sValue.charAt(0) === "#") {
                    stringColor = sValue;
                } else if (this.colorValue[sValue].theme) {
                    stringColor = `var(--q-color-${sValue})`;
                } else {
                    stringColor = this.colorValue[sValue].value;
                }
            }

            return stringColor;
        },
        __removeEntry(guid, data, index, path) {
            const isStrictSubset = (list, subSet) => subSet.every((val, idx) => val === list[idx])
            const max = data.length;
            const splitPath = path.split(",");
            const affectedStates = [this.legacyElementState, this.futureValues];

            for (let loop = index; loop < max; loop++) {
                const currentElement = [...splitPath, "" + loop];
                const isLast = loop === max - 1;

                affectedStates.forEach(state => {
                    Object.keys(state).forEach(key => {
                        const keyPath = key.split(",");

                        if (isStrictSubset(keyPath, currentElement)) {
                            if (isLast) {
                                Vue.delete(state, key);
                            } else {
                                const nextKey = keyPath.toSpliced(splitPath.length, 1, loop + 1).join(",");
                                Vue.set(state, key, state[nextKey]);
                            }
                        }
                    });
                });
            }


            data.splice(index, 1);
            // remove invalid entries
            Object.keys(this.futureValues).forEach(path => {
                const pathList = path.split(",");
                if (pathList.length > 1 && !_has(this.data, pathList)) {
                    Vue.delete(this.futureValues, path);
                }
            });
        },
        __upload(file, hashMapping, hasHash, path = "") {
            let url;
            return new Promise(resolve => {
                if (file) {
                    const formData = new FormData();
                    let taskId = "";
                    let flow = window.localStorage.getItem("executionData");

                    if (flow) {
                        flow = JSON.parse(flow);
                        taskId = flow.taskId || flow.id;
                    }

                    if (file.constructor === File) {
                        url = "/data/attachment/file";
                        formData.append("file", file);
                    } else {
                        const { fileName, base64data } = file;
                        url = "/data/attachment/base64";
                        formData.append("data", base64data);
                        formData.append("suggestedFilename", fileName);
                    }
                    formData.append("taskId", taskId);

                    $http({ type: "POST", url, data: formData }, true)
                        .then(({ data }) => {
                            const { fileUUID, filename: fileName } = data;
                            if (hasHash && hashMapping) {
                                const localPath = path.split(",");
                                localPath.pop();
                                localPath.push(hashMapping);
                                this.__setValueFromPath(localPath, data.hash);
                            }
                            resolve({ fileUUID, fileName });
                        })
                        .catch(() => {
                            Vue.prototype.$toast.showNotify({
                                type: "error",
                                message: "There was a problem while uploading the document",
                                code: "upload_nok",
                                timeout: 2000
                            });
                            resolve(null);
                        });
                } else if (hashMapping && hasHash) {
                    const localPath = path.split(",");
                    localPath.pop();
                    localPath.push(hashMapping);
                    this.__setValueFromPath(localPath, "");
                    resolve();
                }
            });
        },
        __download(fileUUID) {
            const url = `/data/attachment/download/attachment/${fileUUID}`;

            return new Promise(resolve => {
                $http({ type: "GET", url }, true)
                    .then(() => resolve(true))
                    .catch(() => {
                        Vue.prototype.$toast.showNotify({
                            type: "error",
                            message: "There was a problem while downloading the document",
                            code: "download_nok",
                            timeout: 2000
                        });
                        resolve(false);
                    });
            });
        },
        __getDocumentTemplates() {
            return new Promise((resolve, reject) => {
                const url = `/design/documents/templates?applicationId=${this.currentApplicationId}`;
                $http({ url, type: "GET" }, true)
                    .then(({ data }) => {
                        resolve(data.map(({ name, id }) => ({ label: name, value: id })));
                    })
                    .catch(() => {
                        Vue.prototype.$toast.showNotify({
                            type: "error",
                            message: "There was a problem while getting document templates",
                            code: "download_nok",
                            timeout: 2000
                        });
                        resolve([]);
                    });
            });
        },
        async __exportArrayBuffer(arrayBuffer, fn) {
            const suggestedName = sanitizeString(`${fn} ${new Date().toISOString().slice(0, 16).replace("T"," ")}.xlsx`);

            // if (!localSuggestedName) {
            //     const taskData = JSON.parse(localStorage.getItem("executionData"));
            //     const { activityName } = taskData;
            //
            //     localSuggestedName = `${activityName} ${cd.toISOString().slice(0,10)}.xlsx`;
            // }

            const blob = new Blob([arrayBuffer], {
                type: "text/html; charset=utf-8",
                responseType: "arraybuffer"
            });

            if ("showSaveFilePicker" in window) {
                try {
                    const handle = await showSaveFilePicker({ suggestedName });

                    const writable = await handle.createWritable();
                    await writable.write(blob);
                    await writable.close();
                    return;
                } catch (err) {
                    // console.error(err.name, err.message);
                    return;
                }
            }

            const blobURL = URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = blobURL;
            anchor.download = suggestedName;
            anchor.style.display = "none";
            document.body.append(anchor);
            anchor.click();
            setTimeout(() => {
                URL.revokeObjectURL(blobURL);
                anchor.remove();
            }, 1000);

        },
        __exportXLS(payload) {
            const url = "/engine/api/data/exportGridToExcel";
            return new Promise(resolve => {
                $http({ url, type: "POST", data: payload }, true)
                    .then(response => {
                        const blob = new Blob([response.data], {
                            type: response.headers["content-type"],
                            responseType: "arraybuffer"
                        });
                        const downloadUrl = URL.createObjectURL(blob);
                        const anchor = document.createElement("a");
                        anchor.href = downloadUrl;
                        anchor.download = "export.xlsx";
                        document.body.appendChild(anchor);
                        anchor.click();
                        setTimeout(() => {
                            document.body.removeChild(anchor);
                            window.URL.revokeObjectURL(downloadUrl);
                        }, 0);

                        resolve(true);
                    })
                    .catch(() => {
                        resolve(false);
                    });
            });
        },
        __generateDocument(payload) {
            const taskId = window.sessionStorage.getItem("taskId") || "";
            payload.processInstanceId = this.processInstanceId;
            payload.activityId = this.activityId;
            payload.taskId = taskId;
            return new Promise(resolve => {
                // let url = "/documents/templates/generate";
                const url = "/engine/api/rules/generateDocument";
                $http({ url, type: "POST", data: payload }, true)
                    .then(({ data }) => {
                        const { fileUUID, filename: fileName } = data;
                        if (payload.hasHash && payload.hashMapping) {
                            this.$set(this.data, payload.hashMapping, { value: data.hash });
                        }
                        resolve({ fileUUID, fileName });
                    })
                    .catch(() => {
                        resolve(false);
                    });
            });
        },
        __downloadDocument(fileUUID, logAudit) {
            const taskId = window.sessionStorage.getItem("taskId") || ""
            const iframe = document.createElement("iframe");
            iframe.style.display = "none";
            if (logAudit) {
                iframe.src = `/data/attachment/download/attachment/${fileUUID}?taskId=${taskId}`;
            } else {
                iframe.src = `/data/attachment/download/attachment/${fileUUID}`;
            }
            document.body.appendChild(iframe);

            setTimeout(() => {
                document.body.removeChild(iframe);
            }, 5000);
            // window.open(`/data/attachment/download/attachment?attachmentId=${fileUUID}`);
            // let link = document.createElement("a");
            // link.setAttribute("href", `/data/attachment/download/attachment?attachmentId=${fileUUID}`);
            // link.setAttribute("download", "a.pdf");
            // link.click();
        },
        __copyToClipboard(data, msg) {
            copyToClipboard(data, msg);
        },
        __getDataObject() {
            const labels = {};

            Object.entries(this.properties).forEach(([key, data]) => {
                labels[key] = data.label || data.__generics.code || key;
            });

            return { data: extend(true, {}, this.data), labels };
        },
        __isEditable() {
            return (!this.designer && !this.readOnly) || (this.designer && this.live);
        },
        __callTestAPI(mappingObject) {
            return new Promise((resolve, reject) => {
                this.callIntegrationAPI(mappingObject)
                    .then(data => resolve(data))
                    .catch(() => reject());
            });
        },
        __metamaskGetRequestObject(request, _request) {
            const newRequest = {};
            for (let i = 0; i < request.length; i++) {
                newRequest[request[i].name] = request[i].value;
            }
            return new Promise(resolve => {
                if (_request.active) {
                    this.__runRequestScript(_request.content).then(requestData => {
                        resolve(requestData);
                    });
                } else {
                    const requestData = {};
                    const getParentNamespace = guid => {
                        let config;
                        let found = null;
                        let properties = this.properties[guid];
                        let parent = properties && properties.parent ? properties.parent : null;
                        while (!found && parent) {
                            properties = this.properties[parent];
                            config = this.components[properties.__component];
                            if (config.namespace) {
                                found = parent;
                            } else {
                                parent = properties.parent;
                            }
                        }
                        return found;
                    };
                    Object.entries(newRequest).forEach(([key, guid = ""]) => {
                        const path = request.find(entry => entry.name === key);
                        const parentNamespace = getParentNamespace(guid);

                        if (parentNamespace) {
                            if (this.data.hasOwnProperty(parentNamespace)) {
                                const valuesList = this.data[parentNamespace];
                                const pathList = path.split(".");
                                const fieldName = pathList.pop();

                                valuesList.forEach((entry, idx) => {
                                    _set(requestData, [...pathList, idx, fieldName], entry[guid].value);
                                });
                            }
                        } else if (this.data.hasOwnProperty(guid)) {
                            _set(requestData, path.name, this.data.hasOwnProperty(guid) ? this.data[guid].value : null);
                        } else {
                            let code = null;
                            Object.entries(this.properties).forEach(([key, value]) => {
                                if (value.label === guid) {
                                    code = key;
                                }
                            });
                            _set(requestData, path.name, this.data.hasOwnProperty(code) ? this.data[code].value : null);
                        }
                    });
                    resolve(requestData);
                }
            });
        },
        __apiCallGetRequestObject(api, method, request, _request) {
            const attachComponents = ["ctrl-upload"];
            return new Promise(resolve => {
                if (_request.active) {
                    this.__runRequestScript(_request.content).then(resolve);
                } else {
                    const requestData = {};
                    const apiData = this.parsedAPI[api][method];
                    const getParentNamespace = guid => {
                        let config;
                        let found = null;
                        let properties = this.properties[guid];
                        let { parent } = properties;

                        while (!found && parent) {
                            properties = this.properties[parent];
                            config = this.components[properties.__component];
                            if (config.namespace) {
                                found = parent;
                            } else {
                                parent = properties.parent;
                            }
                        }
                        return found;
                    };
                    const addFile = path => {
                        if (!requestData.__files) {
                            requestData.__files = [];
                        }
                        requestData.__files.push({ path });
                    };

                    Object.entries(request).forEach(([key, guid = ""]) => {
                        const { path = null, isList = false } = apiData.request.find(entry => entry.path === key) || {};
                        const parentNamespace = getParentNamespace(guid);
                        const isAttach = attachComponents.includes(this.properties[guid].__component);

                        if (parentNamespace) {
                            if (this.data.hasOwnProperty(parentNamespace)) {
                                const valuesList = this.data[parentNamespace];
                                const pathList = path.split(".");
                                const fieldName = pathList.pop();

                                valuesList.forEach((entry, idx) => {
                                    _set(requestData, isList ? [...pathList, fieldName, idx] : [...pathList, idx, fieldName], entry[guid].value);
                                });
                                if (isAttach) {
                                    addFile([...pathList, fieldName].join("."));
                                }
                            }
                        } else {
                            _set(requestData, path, this.data.hasOwnProperty(guid) ? this.data[guid].value : null);
                            if (isAttach) {
                                addFile(path);
                            }
                        }
                    });

                    resolve(requestData);
                }
            });
        },
        __updateToLatestMetamaskFormat(val) {
            const version = val.hasOwnProperty("version") ? val.version : 0.1;
            let newFormat = null;
            const metamaskRequest = val.request;
            if (version === 0.1) {
                const requestPairs = {};

                newFormat = {};
                Object.entries(val).forEach(([key, value]) => {
                    newFormat[key] = key === "request" ? {} : value;
                });

                metamaskRequest.forEach(entry => {
                    if (!requestPairs.hasOwnProperty(entry.name)) {
                        requestPairs[entry.name] = entry.value;
                    }
                });

                if (val.hasOwnProperty("request")) {
                    const { request } = val;
                    Object.entries(request).forEach(([key, value]) => {
                        newFormat.request[requestPairs[key]] = value;
                    });
                }
            }

            return newFormat || val;
        },
        __searchApiNameByPath(apiPath) {
            const entity = Object.entries(this.parsedAPI || {}).find(
                ([key, value]) => Object.prototype.toString.call(value) === "[object Object]" && Object.values(value)[0]["apiPath"] === apiPath
            );
            return entity !== undefined ? entity[0] : undefined;
        },
        __updateToLatestFormat(val) {
            const version = val.hasOwnProperty("version") ? val.version : 0.1;
            let newFormat = null;

            if (val.hasOwnProperty("api")) {
                const [first, selectedMethod] = val.api.split(".");
                const selectedApi = this.parsedAPI && this.parsedAPI.hasOwnProperty(first) ? first : this.__searchApiNameByPath(first);

                if (selectedApi && selectedMethod) {
                    val.api = `${selectedApi}.${selectedMethod}`;
                    const api = this.parsedAPI && this.parsedAPI[selectedApi];

                    if (api && api.hasOwnProperty(selectedMethod)) {
                        const apiRequest = api[selectedMethod].request || [];

                        if (version === 0.1) {
                            const requestPairs = {};

                            newFormat = {};
                            Object.entries(val).forEach(([key, value]) => {
                                newFormat[key] = key === "request" ? {} : value;
                            });

                            apiRequest.forEach(entry => {
                                if (!requestPairs.hasOwnProperty(entry.name)) {
                                    requestPairs[entry.name] = entry.path;
                                }
                            });

                            if (val.hasOwnProperty("request")) {
                                const { request } = val;
                                Object.entries(request).forEach(([key, value]) => {
                                    newFormat.request[requestPairs[key]] = value;
                                });
                            }
                        }
                    }
                }
            }

            return newFormat || val;
        },
        __startProcess(payload) {
            let guiId = null;
            if (payload.fragmentKey) {
                guiId = this.currentInterfaceModel[payload.fragmentKey].fragment;
            }
            const data = {
                processInstanceId: this.processInstanceId,
                componentKey: payload.componentKey,
                taskId: payload.taskId,
                guiId
            };
            return new Promise(resolve => {
                const url = "/engine/api/processDefinition/start-from-ui";
                $http({ url, type: "POST", data }, true)
                    .then(data => {
                        resolve(data);
                    })
                    .catch(() => {
                        resolve(false);
                    });
            });
        },
        __callAPI(mappingObject, mergeData = false) {
            const mapObject = this.__updateToLatestFormat(mappingObject);
            const { request, _request = {}, response, _response = {} } = mapObject;
            const [api, method] = mapObject.api.split(".");

            return new Promise(resolve => {
                const apiAndMethodGood = this.parsedAPI.hasOwnProperty(api) && this.parsedAPI[api].hasOwnProperty(method);

                if (apiAndMethodGood) {
                    this.__apiCallGetRequestObject(api, method, request, _request).then(request => {
                        const payload = { api: mapObject.api, request };
                        if(this.live) {
                            payload.fromTesting = true;
                        }
                        // generate metamask script
                        this.callIntegrationAPI(payload)
                            .then(({ object }) => {
                                if (_response.active) {
                                    this.__runResponseScript(_response.content, object);
                                } else {
                                    const apiData = object || {};
                                    let dataObject;

                                    // if (apiData.object && apiData.object.constructor === Array) {
                                    //     apiData = { object: apiData.object.length ? apiData.object[0] : {} };
                                    // }

                                    dataObject = this.__parseAPIData(apiData, response);
                                    Object.entries(dataObject).forEach(([key, value]) => {
                                        if (value.constructor === Array) {
                                            if (mergeData) {
                                                const oldValues = this.data[key] || [];
                                                const mergedData = [];
                                                const maxValuesLen = value.length;

                                                oldValues.forEach((entry, idx) => {
                                                    mergedData.push({ ...entry, ...(idx < maxValuesLen ? value[idx] : {}) });
                                                });
                                                this.$set(this.data, key, mergedData);
                                            } else {
                                                this.$set(this.data, key, value);
                                            }
                                        } else {
                                            this.$set(this.data, key, value);
                                        }
                                    });
                                }

                                resolve(true);
                            })
                            .catch(() => resolve(false));
                    });
                } else {
                    Vue.prototype.$toast.showNotify({
                        type: "error",
                        message: `There was a problem with the ${api} API.`,
                        code: "apiNOk",
                        timeout: 2000
                    });
                    resolve(true);
                }
            });
        },
        changeAdd(param) {
            let address = null;
            Object.entries(this.data).forEach(([key, value]) => {
                if (key === param) {
                    address = value.value;
                }
            });
            return address || param;
        },
        prepareResponse(data) {
            const object = {};
            for (let i = 0; i < data.length; i++) {
                object[data[i].name] = data[i].value;
            }
            return object;
        },
        __metamaskCall(payload, mergeData = false) {
            const mapObject = this.__updateToLatestMetamaskFormat(payload);
            const { request, _request = {}, response, _response = {} } = mapObject;
            const objectToSend = {
                contractId: payload.contractId,
                contractName: payload.contractName,
                functionId: payload.functionId,
                functionName: payload.functionName,
                applicationId: this.currentApp.id,
                contractAddress: this.changeAdd(payload.contractAddress) || null
            };
            return new Promise(resolve => {
                this.callMetamaskIntegration(objectToSend).then(script => {
                    this.__metamaskGetRequestObject(request, _request).then(request1 => {
                        const contractFunction = new Function("request", script.data);
                        contractFunction(request1)
                            .then(object => {
                                if (_response.active) {
                                    this.__runResponseScript(_response.content, object);
                                } else {
                                    const apiData = object || {};
                                    let dataObject;
                                    const response1 = this.prepareResponse(response);
                                    dataObject = this.__parseAPIData(apiData, response1);
                                    Object.entries(dataObject).forEach(([key, value]) => {
                                        if (value.constructor === Array) {
                                            if (mergeData) {
                                                const oldValues = this.data[key] || [];
                                                const mergedData = [];
                                                const maxValuesLen = value.length;
                                                oldValues.forEach((entry, idx) => {
                                                    mergedData.push({ ...entry, ...(idx < maxValuesLen ? value[idx] : {}) });
                                                });
                                                this.$set(this.data, key, mergedData);
                                            } else {
                                                this.$set(this.data, key, value);
                                            }
                                        } else if (this.data[key]) {
                                            this.$set(this.data, key, value);
                                        } else {
                                            let code = null;
                                            const key1 = key;
                                            Object.entries(this.properties).forEach(([key, value]) => {
                                                if (value.label === key1 || key === key1) {
                                                    code = key;
                                                }
                                            });
                                            this.$set(this.data, code, value);
                                        }
                                    });
                                }
                                resolve(true);
                            })
                            .catch(() => resolve(false));
                    });
                });
            });
        }
    }
};
